import { setDefaultAssets } from '@leagueplatform/asset-config';
import { WEB_COMMON_ASSETS_MAP } from './asset-map';

export const initModule = () => {
  setDefaultAssets(WEB_COMMON_ASSETS_MAP);
};
